import emailjs from '@emailjs/browser';
import { EMAILJS_CONFIG } from '../config/emailjs.config';


// Mapeamento de valores com emojis e labels
const getFormattedValue = (field: string, value: any): string => {
  if (Array.isArray(value)) {
    return value.length > 0 ? value.join(', ') : 'Não informado';
  }
  
  if (!value) return 'Não informado';
  
  // Mapeamento das opções com emojis e labels
  const optionsMap: { [key: string]: { [key: string]: string } } = {
    tipoServico: {
      'website': '🌐 Website Institucional',
      'ecommerce': '🛒 E-commerce',
      'sistema-web': '💻 Sistema Web',
      'app-mobile': '📱 Aplicativo Mobile',
      'api': '🔗 API/Integração',
      'automacao': '🤖 Automação de Processos',
      'consultoria': '💡 Consultoria Tecnológica',
      'outro': '🎯 Outro (especificar na descrição)'
    },
    prazoDesejado: {
      'urgente': '🚨 Urgente (até 2 semanas)',
      'rapido': '⚡ Rápido (1 mês)',
      'normal': '📅 Normal (2-3 meses)',
      'flexivel': '🕐 Flexível (3+ meses)',
      'nao-sei': '❓ Ainda não sei'
    },
    temSetorTI: {
      'sim-estruturado': '🏢 Sim, bem estruturado',
      'sim-basico': '🔧 Sim, mas bem básico',
      'nao': '❌ Não temos setor de TI',
      'nao-sei': '❓ Ainda não sei'
    },
    jaFezProjetos: {
      'sim-varios': '✅ Sim, já fizemos vários',
      'sim-poucos': '🔄 Sim, mas poucos',
      'nao': '🆕 Não, é nosso primeiro',
      'nao-sei': '❓ Ainda não sei'
    },
    temPrototipos: {
      'sim-detalhado': '🎨 Sim, protótipos bem detalhados',
      'sim-basico': '✏️ Sim, mas são bem básicos',
      'nao': '💡 Não, precisamos criar do zero',
      'nao-sei': '❓ Ainda não sei'
    },
    temDocumentacao: {
      'sim-completa': '📋 Sim, documentação completa',
      'sim-parcial': '📝 Sim, mas ainda incompleta',
      'nao': '🗂️ Não temos documentação',
      'nao-sei': '❓ Ainda não sei'
    },
    temEquipeInterna: {
      'sim-completa': '👥 Sim, equipe completa',
      'sim-parcial': '👤 Sim, mas limitada',
      'nao': '🤝 Não, precisaremos de suporte',
      'nao-sei': '❓ Ainda não sei'
    },
    nivelUrgencia: {
      'alta': '🚀 Alta - Precisa sair rápido',
      'media': '⏰ Média - Temos um prazo',
      'baixa': '🐌 Baixa - Sem pressa',
      'nao-sei': '❓ Ainda não sei'
    },
    orcamento: {
      'ate-10k': '💰 Até R$ 10.000',
      '10k-30k': '💵 R$ 10.000 - R$ 30.000',
      '30k-50k': '💸 R$ 30.000 - R$ 50.000',
      'acima-50k': '🏦 Acima de R$ 50.000',
      'nao-sei': '❓ Ainda não sei'
    },
    quantidadePaginas: {
      'ate-5': '📄 Até 5 páginas',
      '5-10': '📑 5 a 10 páginas',
      '10-20': '📚 10 a 20 páginas',
      'mais-20': '📦 Mais de 20 páginas',
      'nao-sei': '❓ Ainda não sei'
    },
    websiteAnimacoes: {
      'simples': '🔹 Simples e discreto',
      'moderado': '✨ Moderado e elegante',
      'avancado': '💫 Avançado e impactante',
      'nao-sei': '❓ Ainda não sei'
    },
    ecommerceProdutos: {
      'ate-50': '🛍️ Até 50 produtos',
      '50-500': '🏪 50 a 500 produtos',
      'mais-500': '🏬 Mais de 500 produtos',
      'nao-sei': '❓ Ainda não sei'
    },
    ecommercePagamento: {
      'basico': '💳 Apenas os básicos',
      'intermediario': '💰 Vários métodos',
      'completo': '🏦 Sistema completo',
      'nao-sei': '❓ Ainda não sei'
    },
    mobilePlataforma: {
      'android': '🤖 Apenas Android',
      'ios': '🍎 Apenas iOS',
      'ambos': '📱 Android e iOS',
      'nao-sei': '❓ Ainda não sei'
    },
    mobileOffline: {
      'sim-completo': '✅ Sim, completamente',
      'sim-parcial': '🔄 Sim, parcialmente',
      'nao': '🌐 Não, apenas online',
      'nao-sei': '❓ Ainda não sei'
    },
    mobileRecursos: {
      'camera': '📷 Câmera',
      'notificacoes': '🔔 Notificações',
      'pagamentos': '💳 Pagamentos',
      'gps': '📍 GPS/Localização',
      'offline': '📱 Modo Offline',
      'biometria': '👆 Biometria',
      'bluetooth': '📶 Bluetooth',
      'nfc': '📡 NFC'
    },
    androidLicenca: {
      'sim': '✅ Sim, já tenho licença',
      'nao': '❌ Não, preciso adquirir',
      'nao-sei': '❓ Não sei o que é isso'
    },
    iosLicenca: {
      'sim': '✅ Sim, já tenho licença',
      'nao': '❌ Não, preciso adquirir',
      'nao-sei': '❓ Não sei o que é isso'
    },
    sistemaComplexidade: {
      'baixa': '🟢 Baixa complexidade',
      'media': '🟡 Média complexidade',
      'alta': '🔴 Alta complexidade'
    },
    sistemaModulos: {
      'ate-5': '📦 Até 5 módulos',
      '5-10': '📚 5 a 10 módulos',
      'mais-10': '🏢 Mais de 10 módulos'
    },
    sistemaRelatorios: {
      'basico': '📊 Relatórios básicos',
      'intermediario': '📈 Relatórios avançados',
      'completo': '📋 Dashboard completo'
    },
    apiComplexidade: {
      'baixa': '🟢 API simples',
      'media': '🟡 API moderada',
      'alta': '🔴 API complexa'
    },
    apiEndpoints: {
      'ate-10': '🔗 Até 10 endpoints',
      '10-30': '🔗 10 a 30 endpoints',
      'mais-30': '🔗 Mais de 30 endpoints'
    },
    apiAutenticacao: {
      'basica': '🔐 Autenticação básica',
      'jwt': '🎫 JWT Token',
      'oauth': '🔑 OAuth/SSO',
      'completa': '🛡️ Sistema completo'
    },
    apiDatabase: {
      'simples': '🗄️ Banco simples',
      'relacional': '🏗️ Banco relacional',
      'nosql': '📊 NoSQL',
      'hibrido': '🔄 Sistema híbrido'
    },
    automacaoTipo: {
      'web-scraping': '🕷️ Web Scraping',
      'integracao-api': '🔗 Integração de APIs',
      'processamento-dados': '⚙️ Processamento de Dados',
      'relatorios': '📊 Geração de Relatórios'
    },
    automacaoFrequencia: {
      'tempo-real': '⚡ Tempo real',
      'diaria': '📅 Diária',
      'semanal': '📆 Semanal',
      'mensal': '🗓️ Mensal'
    },
    automacaoVolume: {
      'baixo': '📄 Volume baixo',
      'medio': '📚 Volume médio',
      'alto': '🏢 Volume alto'
    },
    automacaoInterface: {
      'nenhuma': '⚫ Sem interface',
      'simples': '🖥️ Interface simples',
      'completa': '💻 Interface completa'
    }
  };
  
  return optionsMap[field]?.[value] || value;
};


// Função simplificada para enviar e-mail de contato
export const sendSimpleContactEmail = async (formData: {
  nome: string;
  empresa: string;
  telefone: string;
  email: string;
  tipoSolucao: string;
  prazoDesejado: string;
}) => {
  try {
    const templateParams = {
      nome: formData.nome,
      empresa: formData.empresa,
      telefone: formData.telefone,
      email: formData.email,
      tipo_solucao: getFormattedValue('tipoServico', formData.tipoSolucao),
      prazo_desejado: getFormattedValue('prazoDesejado', formData.prazoDesejado),
      subject: `Nova Solicitação de Orçamento - ${getFormattedValue('tipoServico', formData.tipoSolucao)} - ${formData.nome}`,
      data_envio: new Date().toLocaleString('pt-BR'),
    };

    const result = await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    );

    return { success: true, result };
  } catch (error) {
    console.error('Erro ao enviar email:', error);
    return { success: false, error };
  }
};
